import React, {Fragment, useState, useRef, useEffect} from "react";
import {
  TextField,
  AppBar,
  Typography,
  Button,
  Grid,
  Toolbar,
  Collapse,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import axios from "axios";
import {Close, Save} from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";
import {Autocomplete, Alert} from "@material-ui/lab";
import {getCookie} from "components/auth/Helpers";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));
const EditLocation = (props) => {
  const token = getCookie("token");
  const [openAlertSuccess, setOpenAlertSuccess] = useState(false);
  const [openAlertError, setOpenAlertError] = useState(false);
  const [clientValue, setClientValue] = useState({});
  const [fridgesTypeValue, setfridgesTypeValue] = useState({});
  const [oldIsNew, setOldIsNew] = useState();
  const [store, setStore] = useState({});
  const [warehouse, setWarehouse] = useState({});
  const [newLocation, setNewLocation] = useState({});
  const classes = useStyles(); //custom css
  const snRef = useRef();
  const sn2Ref = useRef();
  const typeRef = useRef();
  const brandRef = useRef();
  const clientRef = useRef();
  const submitRef = useRef();

  const handleChangeLocation = (e, newValue) => {
    setNewLocation(newValue);
  };
  const handleOnSubmit = async () => {
    if (!newLocation) return setOpenAlertError(true);

    let location_id = null;
    let location_name = "";

    if (newLocation.id == "store" && store && store._id) {
      location_id = store._id;
      location_name = store.name;
    }

    if (newLocation.id == "warehouse" && warehouse && warehouse._id) {
      location_id = warehouse._id;
      location_name = warehouse.name;
    }
    if (props.cabinetId) {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BASE_URL}/cabinets/${props.cabinetId}`,
        data: [
          {
            location: newLocation.id,
            action: "locationUpdate",
            location_id: location_id,
            location_name: location_name,
          },
        ],
        headers: {Authorization: `Bearer ${token}`},
      })
        .then(function (response) {
          setOpenAlertSuccess(true);
          props.handleClose();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <Fragment>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Close onClick={props.handleClose} className="btnIcon" />
          <Typography variant="h6" className={classes.title}>
            {props.title}
          </Typography>
        </Toolbar>
        <Grid item container xs={12} md={12}>
          <Grid item xs={12}>
            <p style={{margin: 0, fontSize: "0.9rem", marginLeft: 50}}>
              <strong>Branding</strong>: {props.cabinet[4] ?? ""} &nbsp;|&nbsp;
              <strong>SN</strong>: {props.cabinet[1] ?? ""} &nbsp;|&nbsp;
              <strong>Status</strong>: {props.cabinet[13] ?? ""}
            </p>
          </Grid>
        </Grid>
      </AppBar>
      <Collapse in={openAlertSuccess}>
        <Alert severity="success" onClick={() => setOpenAlertSuccess(false)}>
          Status Updated
        </Alert>
      </Collapse>
      <Collapse in={openAlertError}>
        <Alert severity="error" onClick={() => setOpenAlertError(false)}>
          Missing Status
        </Alert>
      </Collapse>

      <div style={{padding: "10px 30px"}}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id="location"
              options={[
                {id: "store", name: "Store"},

                {id: "warehouse", name: "Warehouse"},
              ]}
              value={newLocation || {}}
              getOptionLabel={(option) => {
                return Object.keys(option).length !== 0 ? `${option.name}` : "";
              }}
              fullWidth
              onChange={handleChangeLocation}
              renderInput={(params) => (
                <TextField {...params} label="Fridge New Location" inputRef={typeRef} />
              )}
            />
          </Grid>

          {newLocation.id == "store" && (
            <Grid item xs={12} sm={12}>
              <Autocomplete
                id="store"
                options={props.storesList}
                value={store || {}}
                getOptionLabel={(option) => {
                  return Object.keys(option).length !== 0 ? `${option.name}` : "";
                }}
                fullWidth
                onChange={(e, v) => setStore(v)}
                renderInput={(params) => <TextField {...params} label="Store" inputRef={typeRef} />}
              />
            </Grid>
          )}

          {newLocation.id == "warehouse" && (
            <Grid item xs={12} sm={12}>
              <Autocomplete
                id="warehouse"
                options={props.warehousesList}
                value={warehouse || {}}
                getOptionLabel={(option) => {
                  return Object.keys(option).length !== 0 ? `${option.name}` : "";
                }}
                fullWidth
                onChange={(e, v) => setWarehouse(v)}
                renderInput={(params) => <TextField {...params} label="Warehouse" inputRef={typeRef} />}
              />
            </Grid>
          )}

          <Grid item xs={12} className="clientTables">
            <Button
              variant="contained"
              color="primary"
              size="large"
              className="btn btn--save"
              type="submit"
              startIcon={<Save />}
              ref={submitRef}
              onClick={handleOnSubmit}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              className="btn btn--save"
              onClick={props.handleClose}
              startIcon={<Close />}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default EditLocation;
